import { render, staticRenderFns } from "./RevenueByModuleStatistics.vue?vue&type=template&id=2b67a618&scoped=true&"
import script from "./RevenueByModuleStatistics.vue?vue&type=script&lang=ts&"
export * from "./RevenueByModuleStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./RevenueByModuleStatistics.vue?vue&type=style&index=0&id=2b67a618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b67a618",
  null
  
)

export default component.exports